module.exports = __webpack_public_path__ + "img/pic23.1dc94607.png";